import { Component } from '@angular/core';
import {
  UserType,
  UpdateCurrentUser,
  UpdateUser,
} from '../../models/user.model';
import { ProfileSettingsProvider } from '../../providers/profile-settings/profile-settings';
import { Api } from '../../providers/providers';
import { ToastController } from 'ionic-angular';

/**
 * Generated class for the ProfileAboutComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'profile-about',
  templateUrl: 'profile-about.html',
})
export class ProfileAboutComponent {
  user: UserType = new UserType();

  constructor(
    public toastCtrl: ToastController,
    private api: Api,
    private profileSettingsProvider: ProfileSettingsProvider
  ) {
    console.log('Hello ProfileAboutComponent Component');
  }

  getUserInfo(): void {
    this.profileSettingsProvider
      .getCurrentUser()
      .subscribe((response: UserType) => {
        this.user = response;
        //this.getUserInterests();
      });
  }

  updateUserInfo(user: UserType): void {
    this.profileSettingsProvider
      .updateUser(this.mapUserObject(user))
      .subscribe((response: UserType) => {
        this.toastCtrl
          .create({
            message: 'User successfully updated!',
            duration: 3000,
            position: 'top',
          })
          .present();
      });

    //this.updateUserInterest();
  }

  async mapUserObject(user: UserType) {
    const updateUser = new UpdateUser();
    updateUser.firstName = user.firstName;
    updateUser.lastName = user.lastName;
    updateUser.about = user.about;
    updateUser.lookFor = user.lookFor;
    updateUser.offer = user.offer;
    updateUser.title = user.title;
    updateUser.company = user.company;
    updateUser.country = user.country;
    updateUser.countryCode = user.countryCode;
    updateUser.email2 = user.email2;
    updateUser.isNewMailVerified = user.isNewMailVerified;
    return updateUser;
  }
}



// WEBPACK FOOTER //
// ./src/components/profile-about/profile-about.ts